import Head from 'next/head';
import type { ReactElement } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Building2, Shield, Users } from 'lucide-react';
import { CompanyInfoForm } from '@/components/corporate/company-info-form';

export default function CorporateOverview(): ReactElement {
  return (
    <>
      <Head>
        <title>Corporate Overview – KEM Discovery</title>
        <meta name="description" content="How to set up KEM Discovery for your organization." />
      </Head>

      <div className="mx-auto max-w-5xl">
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight mb-2">Corporate [Coming Soon]</h1>
        <p className="text-muted-foreground mb-8">Tell us about your organization and our team will help you set up KEM Discovery with SSO for your team.</p>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <CompanyInfoForm />

          <Card className="border-0 shadow-md">
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Building2 className="size-5" />
                Why Choose KEM Discovery?
              </CardTitle>
            </CardHeader>
            <CardContent className="text-sm text-muted-foreground space-y-3">
              <div className="flex items-start gap-2">
                <Shield className="size-4 mt-0.5 text-blue-600" />
                <div>
                  <strong>Enterprise SSO Ready</strong><br/>
                  Supports integration with 100+ providers
                </div>
              </div>
              <div className="flex items-start gap-2">
                <Users className="size-4 mt-0.5 text-blue-600" />
                <div>
                  <strong>Team Management</strong><br/>
                  Centralized dashboard and insights
                </div>
              </div>
              <div className="pt-2 text-xs text-muted-foreground">
                Our team will guide you through every step of the setup process.
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </>
  );
}


